<div class="simulador" [class.simulador--widget]="!ehPainel">
  <!-- cabeçalho (só no painel — o widget tem a casca própria com a marca da loja) -->
  <header class="simulador__cabecalho" *ngIf="ehPainel">
    <div class="simulador__identidade">
      <div class="simulador__avatar">
        <i class="fas fa-robot"></i>
      </div>
      <div>
        <h4>Testar Mia V3</h4>
        <small>Converse com a Mia como se você fosse o cliente — sem WhatsApp, sem afetar clientes reais.</small>
      </div>
    </div>
    <div class="simulador__acoes">
      <button class="simulador__toggle" [class.simulador__toggle--ativo]="clienteNovoTeste"
              (click)="clienteNovoTeste = !clienteNovoTeste"
              title="Ignora o endereço salvo do contato de teste para exercitar o fluxo de localização (cliente sem cadastro)">
        <i class="fas" [class.fa-user-plus]="clienteNovoTeste" [class.fa-user]="!clienteNovoTeste"></i>
        {{ clienteNovoTeste ? 'Cliente novo (sem endereço)' : 'Cliente com endereço salvo' }}
      </button>
      <button class="simulador__toggle" [class.simulador__toggle--ativo]="pedidoAbertoTeste"
              (click)="pedidoAbertoTeste = !pedidoAbertoTeste"
              title="A Mia recebe um pedido em aberto fictício (#4521, em preparação, feito há 15 min) como se o cliente tivesse acabado de pedir — nenhum pedido é criado de verdade">
        <i class="fas" [class.fa-receipt]="pedidoAbertoTeste" [class.fa-shopping-bag]="!pedidoAbertoTeste"></i>
        {{ pedidoAbertoTeste ? 'Com pedido em aberto (#4521)' : 'Sem pedido em aberto' }}
      </button>
      <button class="simulador__nova" *ngIf="ehPainel" (click)="adianteFollowup()" [disabled]="followupAdiantando"
              title="Antecipa o próximo lembrete proativo pendente desta conversa — o worker envia agora, passando por todas as guardas">
        <i class="far fa-bell"></i> Adiantar follow-up
      </button>
      <button class="simulador__nova" (click)="novaConversa()" [disabled]="digitando"
              title="Zera o contexto e começa uma conversa do zero">
        <i class="fas fa-redo-alt"></i> Nova conversa
      </button>
    </div>
  </header>

  <!-- aviso de problema técnico (instruções internas — nunca no widget) -->
  <div class="simulador__aviso" *ngIf="avisoTecnico && ehPainel">
    <i class="fas fa-exclamation-triangle"></i>
    <div>
      <strong>A Mia respondeu com o fallback técnico.</strong>
      Verifique se a <code>mia-v3</code> está rodando com a <code>ANTHROPIC_API_KEY</code> configurada
      (arquivo <code>mia-v3/.env</code>) e reinicie o serviço.
    </div>
    <button (click)="avisoTecnico = false"><i class="fas fa-times"></i></button>
  </div>

  <!-- corpo do chat -->
  <div class="simulador__corpo" #corpoChat>
    <!-- estado inicial: sugestões -->
    <div class="simulador__boasvindas" *ngIf="mensagens.length === 0 && !digitando">
      <div class="simulador__boasvindas-icone"><i class="fas fa-comment-dots"></i></div>
      <h5>Comece a conversa</h5>
      <p *ngIf="ehPainel">Escreva como um cliente escreveria no WhatsApp,<br>ou use uma das sugestões abaixo:</p>
      <p *ngIf="!ehPainel">Pergunte o que quiser — cardápio, preços, entrega —<br>ou use uma das sugestões abaixo:</p>
      <div class="simulador__sugestoes">
        <button *ngFor="let sugestao of sugestoes" (click)="envieSugestao(sugestao)">
          {{ sugestao }}
        </button>
      </div>
    </div>

    <!-- mensagens -->
    <div class="simulador-bolha-wrapper"
         *ngFor="let mensagem of mensagens"
         [class.simulador-bolha-wrapper--direita]="mensagem.papel === 'cliente' && !mensagem.notaSistema"
         [class.simulador-bolha-wrapper--centro]="mensagem.notaSistema">

      <!-- recado do simulador (silêncio da Mia, takeover, devolução) — não é
           mensagem da conversa, por isso vem centralizado e sem bolha -->
      <div class="simulador-nota" *ngIf="mensagem.notaSistema">
        <span>{{ mensagem.notaSistema }}</span>
      </div>

      <div class="simulador-bolha" *ngIf="!mensagem.notaSistema"
           [class.simulador-bolha--cliente]="mensagem.papel === 'cliente'"
           [class.simulador-bolha--mia]="mensagem.papel === 'mia' && !mensagem.erroTecnico"
           [class.simulador-bolha--erro]="mensagem.erroTecnico"
           [class.simulador-bolha--com-imagem]="mensagem.imagem"
           [class.simulador-bolha--com-reacao]="mensagem.reacao">
        <!-- reação da Mia: emoji pendurado no canto da bolha, como no WhatsApp -->
        <span class="simulador-bolha__reacao" *ngIf="mensagem.reacao">{{ mensagem.reacao }}</span>
        <a *ngIf="mensagem.imagem" [href]="mensagem.imagem" target="_blank" class="simulador-bolha__imagem">
          <img [src]="mensagem.imagem" alt="Foto do produto" loading="lazy" />
        </a>

        <!-- áudio do cliente: o binário sobe para o STT, o player usa o blob local -->
        <div class="simulador-audio" *ngIf="mensagem.audio">
          <audio #player [src]="mensagem.audio.urlSegura"
                 (play)="sigaAReproducao(player, marcador, mensagem.audio.duracaoSegundos)"
                 (pause)="pareDeSeguirAReproducao(player)"
                 (timeupdate)="marqueOndaDaBolha(mensagem, player.currentTime, player.duration)"
                 (ended)="player.currentTime = 0; marqueOndaDaBolha(mensagem, 0, player.duration); zereOMarcador(marcador, player)"></audio>
          <button class="simulador-audio__tocar" type="button"
                  (click)="player.paused ? player.play() : player.pause()"
                  [title]="player.paused ? 'Ouvir o áudio' : 'Pausar'">
            <i class="fas" [class.fa-play]="player.paused" [class.fa-pause]="!player.paused"></i>
          </button>
          <!-- onda real do arquivo, preenchendo conforme toca (sem ela, traço fino) -->
          <div class="simulador-audio__onda" [class.simulador-audio__onda--lisa]="!mensagem.audio.onda.length">
            <span *ngFor="let altura of mensagem.audio.onda; let i = index"
                  [style.height.%]="altura"
                  [class.simulador-audio__barra--tocada]="i <= mensagem.audio.tocado"></span>
            <!-- marcador da posição atual, como a bolinha do WhatsApp. Fica
                 sempre no DOM: quem move é o rAF, não o change detection -->
            <b #marcador class="simulador-audio__marcador"
               [class.simulador-audio__marcador--visivel]="mensagem.audio.tocado >= 0"></b>
          </div>
          <span class="simulador-audio__tempo">{{ duracaoEmMinutos(mensagem.audio.duracaoSegundos) }}</span>
        </div>
        <!-- o que a Mia entendeu: só no testador, para conferir o STT (no
             WhatsApp o cliente vê a bolha de áudio e nada mais) -->
        <p class="simulador-audio__transcricao" *ngIf="mensagem.audio?.transcricao">
          <i class="fas fa-quote-left"></i> {{ mensagem.audio.transcricao }}
        </p>
        <div class="simulador-bolha__texto" *ngIf="mensagem.texto"
             [innerHTML]="textoSemLink(mensagem) | formataWhatsapp"></div>

        <!-- link vira botão CTA, como o cta_url da Cloud API -->
        <ng-container *ngIf="linkDaMensagem(mensagem) as link">
          <!-- rodapé do cta_url (config da loja ou padrão), como no WhatsApp real -->
          <div class="simulador-bolha__rodape" *ngIf="mensagem.linkCta && mensagem.ctaRodape">
            {{ mensagem.ctaRodape }}
          </div>
          <div class="simulador-cta">
            <a [href]="link" target="_blank">
              <i class="fas fa-external-link-alt"></i> {{ rotuloDoLink(mensagem, link) }}
            </a>
          </div>
        </ng-container>

        <!-- reply buttons (Cloud API: até 3) — cliques ck_* vão à máquina do checkout -->
        <div class="simulador-botoes" *ngIf="mensagem.botoes?.length">
          <button *ngFor="let botao of mensagem.botoes" (click)="cliqueBotao(botao)" [disabled]="digitando">
            {{ botao.titulo }}
          </button>
        </div>

        <!-- list message (Cloud API: até 10 itens) — abre o bottom sheet -->
        <div class="simulador-lista" *ngIf="mensagem.lista">
          <button class="simulador-lista__abrir" (click)="abraLista(mensagem)">
            <i class="fas fa-list-ul"></i> {{ mensagem.lista.rotulo }}
          </button>
        </div>

        <!-- mensagem de Flow da vitrine (como o WhatsApp real enviaria) -->
        <div class="simulador-lista" *ngIf="mensagem.flowVitrine">
          <button class="simulador-lista__abrir simulador-lista__abrir--vitrine" (click)="abraVitrine(mensagem)">
            <i class="fas fa-images"></i> {{ mensagem.rotuloFlow || 'Abrir vitrine 📸' }}
          </button>
        </div>

        <!-- mensagem de Flow do checkout (só pagamento/troco/confirmação) -->
        <div class="simulador-lista" *ngIf="mensagem.flowCheckout">
          <button class="simulador-lista__abrir simulador-lista__abrir--vitrine" (click)="abraCheckout(mensagem)">
            <i class="fas fa-receipt"></i> Finalizar pagamento
          </button>
        </div>

        <!-- location_request_message (botão nativo do WhatsApp na bolha) -->
        <div class="simulador-lista" *ngIf="mensagem.pedirLocalizacao">
          <button class="simulador-lista__abrir simulador-lista__abrir--vitrine"
                  (click)="envieLocalizacaoNaConversa()" [disabled]="localizacaoEnviando || digitando">
            <i class="fas fa-map-marker-alt"></i> {{ localizacaoEnviando ? 'Enviando…' : 'Enviar localização' }}
          </button>
        </div>
        <!-- ferramentas usadas pelo agente neste turno (debug de dev) -->
        <div class="simulador-ferramentas" *ngIf="ehPainel && (mensagem.ferramentas?.length || mensagem.avisoPreco)">
          <span class="simulador-ferramentas__chip"
                *ngFor="let ferramenta of mensagem.ferramentas"
                [class.simulador-ferramentas__chip--erro]="!ferramenta.sucesso"
                [title]="(ferramenta.argumentos | json) + ' · ' + ferramenta.duracaoMs + 'ms'">
            <i class="fas" [class.fa-wrench]="ferramenta.sucesso" [class.fa-exclamation-triangle]="!ferramenta.sucesso"></i>
            {{ ferramenta.nome }}
          </span>
          <span class="simulador-ferramentas__chip simulador-ferramentas__chip--erro"
                *ngIf="mensagem.avisoPreco"
                title="O checador de fatos não encontrou origem para este valor nos dados do turno (cardápio, ferramentas ou carrinho)">
            <i class="fas fa-exclamation-triangle"></i> preço não verificado: {{ mensagem.avisoPreco }}
          </span>
        </div>

        <div class="simulador-bolha__meta">
          <span class="simulador-bolha__telemetria" *ngIf="ehPainel && mensagem.telemetria"
                [title]="descricaoTelemetria(mensagem.telemetria)">
            <i class="fas fa-bolt"></i> {{ descricaoTelemetria(mensagem.telemetria) }}
          </span>
          {{ mensagem.horario | date:'HH:mm:ss' }}
        </div>
      </div>
    </div>

    <!-- indicador "digitando" -->
    <div class="simulador-bolha-wrapper" *ngIf="digitando">
      <div class="simulador-bolha simulador-bolha--mia simulador-digitando">
        <span></span><span></span><span></span>
      </div>
    </div>
  </div>

  <!-- barra do carrinho montado pela Mia -->
  <div class="simulador-carrinho" *ngIf="carrinho?.totalItens">
    <button class="simulador-carrinho__barra" (click)="carrinhoAberto = !carrinhoAberto">
      <span class="simulador-carrinho__icone"><i class="fas fa-shopping-cart"></i></span>
      <span class="simulador-carrinho__resumo">
        {{ carrinho.totalItens }} {{ carrinho.totalItens === 1 ? 'item' : 'itens' }} no carrinho
      </span>
      <strong class="simulador-carrinho__total">R$ {{ carrinho.total | number:'1.2-2' }}</strong>
      <i class="fas" [class.fa-chevron-up]="!carrinhoAberto" [class.fa-chevron-down]="carrinhoAberto"></i>
    </button>
    <div class="simulador-carrinho__itens" *ngIf="carrinhoAberto">
      <div class="simulador-carrinho__item" *ngFor="let item of carrinho.itens">
        <div class="simulador-carrinho__item-info">
          <span class="simulador-carrinho__item-titulo">{{ item.quantidade }}x {{ item.titulo }}</span>
          <small *ngIf="item.detalhes">{{ item.detalhes }}</small>
          <small *ngIf="item.observacao"><i class="fas fa-comment-dots"></i> {{ item.observacao }}</small>
        </div>
        <span class="simulador-carrinho__item-preco">R$ {{ item.subtotal | number:'1.2-2' }}</span>
      </div>
    </div>
  </div>

  <!-- bottom sheet da lista (como no WhatsApp oficial) -->
  <div class="simulador-sheet" *ngIf="listaAberta">
    <div class="simulador-sheet__fundo" (click)="fecheLista()"></div>
    <div class="simulador-sheet__painel">
      <header class="simulador-sheet__cabecalho">
        <span>{{ listaAberta.lista?.rotulo || 'Selecione uma opção' }}</span>
        <button (click)="fecheLista()" title="Fechar"><i class="fas fa-times"></i></button>
      </header>

      <div class="simulador-sheet__itens">
        <label class="simulador-sheet__item"
               *ngFor="let item of listaAberta.lista?.itens"
               [class.simulador-sheet__item--ativo]="opcaoSelecionada === item.titulo"
               [class.simulador-sheet__item--vitrine]="item.id === 'vitrine' || item.id === 'mais_categorias'"
               (click)="opcaoSelecionada = item.titulo">
          <span class="simulador-sheet__textos">
            <span class="simulador-sheet__titulo">{{ item.titulo }}</span>
            <span class="simulador-sheet__descricao" *ngIf="item.descricao">{{ item.descricao }}</span>
          </span>
          <span class="simulador-sheet__radio" [class.simulador-sheet__radio--marcado]="opcaoSelecionada === item.titulo"></span>
        </label>
      </div>

      <footer class="simulador-sheet__rodape">
        <button class="simulador-sheet__enviar" [disabled]="!opcaoSelecionada" (click)="confirmeLista()">
          <i class="fas fa-paper-plane"></i> Enviar
        </button>
      </footer>
    </div>
  </div>

  <!-- bottom sheet da vitrine de fotos (simula o WhatsApp Flow) -->
  <div class="simulador-sheet" *ngIf="vitrineAberta">
    <div class="simulador-sheet__fundo" (click)="fecheVitrine()"></div>
    <div class="simulador-sheet__painel">
      <header class="simulador-sheet__cabecalho">
        <span><i class="fas fa-images"></i> Vitrine</span>
        <button (click)="fecheVitrine()" title="Fechar"><i class="fas fa-times"></i></button>
      </header>

      <div class="simulador-sheet__itens">
        <label class="simulador-vitrine__card"
               *ngFor="let produto of vitrineAberta.vitrine?.produtos"
               [class.simulador-vitrine__card--ativo]="produtoVitrineSelecionado?.id === produto.id"
               (click)="produtoVitrineSelecionado = produto">
          <img class="simulador-vitrine__foto" [src]="produto.imagem" [alt]="produto.nome" loading="lazy" />
          <span class="simulador-vitrine__textos">
            <span class="simulador-vitrine__nome">{{ produto.nome }}</span>
            <span class="simulador-vitrine__preco" *ngIf="precoDaVitrine(produto)">{{ precoDaVitrine(produto) }}</span>
            <span class="simulador-vitrine__descricao" *ngIf="produto.descricao">{{ produto.descricao }}</span>
          </span>
          <span class="simulador-sheet__radio"
                [class.simulador-sheet__radio--marcado]="produtoVitrineSelecionado?.id === produto.id"></span>
        </label>
      </div>

      <footer class="simulador-sheet__rodape">
        <button class="simulador-sheet__enviar" [disabled]="!produtoVitrineSelecionado" (click)="confirmeVitrine()">
          <i class="fas fa-check"></i> Escolher
        </button>
      </footer>
    </div>
  </div>

  <!-- bottom sheet do checkout (simula o WhatsApp Flow de fechamento, em telas) -->
  <div class="simulador-sheet" *ngIf="checkoutAberto">
    <div class="simulador-sheet__fundo" (click)="fecheCheckout()"></div>
    <div class="simulador-sheet__painel">
      <header class="simulador-sheet__cabecalho">
        <span>
          <button class="simulador-checkout__voltar" *ngIf="checkoutPasso > 1" (click)="volteCheckout()" title="Voltar">
            <i class="fas fa-arrow-left"></i>
          </button>
          <i class="fas fa-receipt" *ngIf="checkoutPasso === 1"></i>
          {{ checkoutTituloDoPasso }}
        </span>
        <button (click)="fecheCheckout()" title="Fechar"><i class="fas fa-times"></i></button>
      </header>

      <div class="simulador-sheet__itens simulador-checkout">
        <p class="simulador-checkout__erro" *ngIf="checkoutErro">⚠️ {{ checkoutErro }}</p>

        <!-- resumo do pedido (modo/endereço/taxa/total já resolvidos na conversa) -->
        <div class="simulador-checkout__taxa" *ngIf="checkoutResumoTexto">
          <i class="fas fa-receipt"></i> {{ checkoutResumoTexto }}
        </div>

        <ng-container *ngIf="checkoutOpcoes">
          <!-- tela 1: pagamento -->
          <ng-container *ngIf="checkoutPasso === 1">
            <label class="simulador-sheet__item" *ngFor="let forma of checkoutOpcoes.formasDePagamento"
                   [class.simulador-sheet__item--ativo]="checkoutPagamento?.id === forma.id"
                   (click)="checkoutPagamento = forma">
              <span class="simulador-sheet__textos">
                <span class="simulador-sheet__titulo">{{ forma.descricao }}</span>
              </span>
              <span class="simulador-sheet__radio" [class.simulador-sheet__radio--marcado]="checkoutPagamento?.id === forma.id"></span>
            </label>
          </ng-container>

          <!-- tela 2: troco (só quando a forma pede) -->
          <ng-container *ngIf="checkoutPasso === 2">
            <label class="simulador-sheet__item"
                   [class.simulador-sheet__item--ativo]="!checkoutPrecisaTroco"
                   (click)="checkoutPrecisaTroco = false; checkoutTroco = null">
              <span class="simulador-sheet__textos">
                <span class="simulador-sheet__titulo">Não preciso de troco</span>
              </span>
              <span class="simulador-sheet__radio" [class.simulador-sheet__radio--marcado]="!checkoutPrecisaTroco"></span>
            </label>
            <label class="simulador-sheet__item"
                   [class.simulador-sheet__item--ativo]="checkoutPrecisaTroco"
                   (click)="checkoutPrecisaTroco = true">
              <span class="simulador-sheet__textos">
                <span class="simulador-sheet__titulo">Preciso de troco para…</span>
                <span class="simulador-sheet__descricao">informe com quanto vai pagar</span>
              </span>
              <span class="simulador-sheet__radio" [class.simulador-sheet__radio--marcado]="checkoutPrecisaTroco"></span>
            </label>
            <div class="simulador-checkout__troco" *ngIf="checkoutPrecisaTroco">
              <input type="number" min="0" [(ngModel)]="checkoutTroco" placeholder="ex.: 100" autofocus />
            </div>
          </ng-container>
        </ng-container>

        <p class="simulador-checkout__carregando" *ngIf="!checkoutOpcoes && !checkoutErro">Carregando opções…</p>
      </div>

      <footer class="simulador-sheet__rodape">
        <button class="simulador-sheet__enviar" [disabled]="!checkoutPodeAvancar" (click)="avanceCheckout()">
          <i class="fas"
             [class.fa-arrow-right]="checkoutPasso < checkoutUltimoPasso && !checkoutEnviando"
             [class.fa-check]="checkoutPasso >= checkoutUltimoPasso && !checkoutEnviando"
             [class.fa-spinner]="checkoutEnviando" [class.fa-spin]="checkoutEnviando"></i>
          {{ checkoutRotuloAvancar }}
        </button>
      </footer>
    </div>
  </div>

  <!-- painel do microfone: dispositivo, nível ao vivo e teste de gravação -->
  <div class="simulador-sheet" *ngIf="microfoneAberto">
    <div class="simulador-sheet__fundo" (click)="fecheMicrofone()"></div>
    <div class="simulador-sheet__painel">
      <div class="simulador-sheet__cabecalho">
        <span>Microfone</span>
        <button (click)="fecheMicrofone()" title="Fechar"><i class="fas fa-times"></i></button>
      </div>

      <div class="simulador-mic">
        <!-- o problema vem primeiro e com a próxima ação, como no Meet -->
        <div class="simulador-mic__alerta" *ngIf="problemaDoMicrofone">
          <i class="fas fa-exclamation-circle"></i>
          <div>
            <strong>{{ problemaDoMicrofone.titulo }}</strong>
            <span>{{ problemaDoMicrofone.descricao }}</span>
          </div>
          <button *ngIf="problemaDoMicrofone.rotuloAcao" (click)="acaoDoProblema()">
            {{ problemaDoMicrofone.rotuloAcao }}
          </button>
        </div>

        <label class="simulador-mic__rotulo" for="micDispositivo">Dispositivo</label>
        <select id="micDispositivo" class="simulador-mic__select"
                [ngModel]="gravador.deviceIdEscolhido || ''" (ngModelChange)="troqueMicrofone($event)"
                [disabled]="gravando || gravandoTeste"
                [title]="gravando || gravandoTeste ? 'Pare a gravação para trocar o microfone' : ''">
          <option value="">Microfone padrão do sistema</option>
          <option *ngFor="let microfone of gravador.microfones" [value]="microfone.deviceId">
            {{ microfone.rotulo }}
          </option>
        </select>
        <p class="simulador-mic__dica" *ngIf="gravando || gravandoTeste">
          <i class="fas fa-lock"></i>
          Gravando — pare para trocar de microfone.
        </p>

        <label class="simulador-mic__rotulo">Nível de entrada</label>
        <div class="simulador-mic__medidor" #medidorPainel>
          <span *ngFor="let barra of barrasDoMedidor"></span>
        </div>
        <p class="simulador-mic__dica">
          <i class="fas fa-info-circle"></i>
          Fale alguma coisa — as barras precisam se mexer.
        </p>

        <div class="simulador-mic__teste">
          <button class="simulador-mic__botao" (click)="graveTesteDeMicrofone()" [disabled]="gravando"
                  [title]="gravando ? 'Há uma gravação de mensagem em andamento' : ''">
            <i class="fas" [class.fa-circle]="!gravandoTeste" [class.fa-stop]="gravandoTeste"></i>
            {{ gravandoTeste ? 'Parar (' + segundosGravados + 's)' : 'Gravar 5s e ouvir' }}
          </button>

          <div class="simulador-mic__previa" *ngIf="audioDeTeste">
            <audio #teste [src]="audioDeTeste.urlSegura" (ended)="teste.currentTime = 0"></audio>
            <button class="simulador-mic__botao" (click)="teste.paused ? teste.play() : teste.pause()">
              <i class="fas" [class.fa-play]="teste.paused" [class.fa-pause]="!teste.paused"></i>
              Ouvir o teste
            </button>
            <span class="simulador-mic__mudo" *ngIf="audioDeTeste.mudo">
              <i class="fas fa-volume-mute"></i> Saiu mudo
            </span>
          </div>
        </div>
      </div>

      <footer class="simulador-sheet__rodape">
        <button class="simulador-sheet__enviar" (click)="graveAgoraPeloPainel()"
                [disabled]="gravandoTeste || !!problemaDoMicrofone?.bloqueia">
          <i class="fas fa-microphone"></i> Começar a gravar
        </button>
      </footer>
    </div>
  </div>

  <!-- takeover: o áudio passou a conversa para um humano (ou o painel assumiu) -->
  <div class="simulador__takeover" *ngIf="emAtendimentoHumano">
    <i class="fas fa-headset"></i>
    <div>
      <strong>Conversa em atendimento humano.</strong>
      A Mia parou de responder aqui, igual ao WhatsApp.
    </div>
    <button (click)="devolvaParaMia()" [disabled]="devolvendoParaMia">
      <i class="fas" [class.fa-undo]="!devolvendoParaMia"
         [class.fa-spinner]="devolvendoParaMia" [class.fa-spin]="devolvendoParaMia"></i>
      Devolver para a Mia
    </button>
  </div>

  <!-- diagnóstico do microfone junto da barra, no espírito do Meet -->
  <div class="simulador__alerta-mic" *ngIf="problemaDoMicrofone && !microfoneAberto">
    <i class="fas fa-exclamation-circle"></i>
    <div class="simulador__alerta-mic__texto">
      <strong>{{ problemaDoMicrofone.titulo }}</strong>
      <span>{{ problemaDoMicrofone.descricao }}</span>
    </div>
    <button class="simulador__alerta-mic__acao" *ngIf="problemaDoMicrofone.rotuloAcao" (click)="acaoDoProblema()">
      {{ problemaDoMicrofone.rotuloAcao }}
    </button>
    <button class="simulador__alerta-mic__fechar" (click)="gravador.limpeProblema()" title="Dispensar">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <!-- imagem anexada aguardando envio (o texto digitado vira a legenda) -->
  <div class="simulador__anexo" *ngIf="imagemPendente">
    <img [src]="imagemPendente.preview" alt="Imagem anexada" />
    <span>Imagem anexada — o texto vira a legenda</span>
    <button (click)="removaImagemPendente()" title="Remover imagem">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="simulador__anexo simulador__anexo--erro" *ngIf="erroImagem">{{ erroImagem }}</div>
  <div class="simulador__anexo simulador__anexo--erro" *ngIf="audioPendente?.mudo">
    Este áudio saiu mudo — dá para enviar assim mesmo, mas vale regravar.
  </div>

  <!-- Barra de áudio, no formato do WhatsApp Web: UMA barra que muda de estado
       (gravando ⇄ pré-envio). Lixeira sempre à esquerda, enviar sempre à
       direita — nada de controle pulando de lugar entre um estado e outro. -->
  <footer class="simulador-gravacao" *ngIf="gravando || audioPendente">
    <button class="simulador-gravacao__icone" (click)="descarteAGravacao()"
            [title]="gravando ? 'Descartar gravação' : 'Descartar áudio'">
      <i class="fas fa-trash-alt"></i>
    </button>

    <!-- gravando (segue exibindo até a prévia da pausa ficar pronta, para a
         barra não piscar vazia no instante do ⏸) -->
    <ng-container *ngIf="gravando && !audioPendente">
      <span class="simulador-gravacao__rec"></span>
      <span class="simulador-gravacao__tempo">{{ duracaoEmMinutos(segundosGravados) }}</span>
      <div class="simulador-gravacao__onda" #medidorGravacao>
        <span *ngFor="let ponto of barrasDoMedidor"></span>
      </div>
      <button class="simulador-gravacao__icone simulador-gravacao__icone--rec"
              (click)="pauseAGravacao()" title="Pausar (dá para continuar depois)">
        <i class="fas fa-pause"></i>
      </button>
    </ng-container>

    <!-- pausado (dá para ouvir e continuar) ou finalizado, antes de enviar -->
    <ng-container *ngIf="audioPendente">
      <audio #previa [src]="audioPendente.urlSegura"
             (play)="sigaAReproducao(previa, marcadorPrevia, audioPendente.duracaoSegundos)"
             (pause)="pareDeSeguirAReproducao(previa)"
             (timeupdate)="marqueProgressoDaPrevia(previa.currentTime)"
             (ended)="previa.currentTime = 0; marqueProgressoDaPrevia(0); zereOMarcador(marcadorPrevia, previa)"></audio>
      <button class="simulador-gravacao__icone" (click)="previa.paused ? previa.play() : previa.pause()"
              [title]="previa.paused ? 'Ouvir antes de enviar' : 'Pausar'">
        <i class="fas" [class.fa-play]="previa.paused" [class.fa-pause]="!previa.paused"></i>
      </button>
      <div class="simulador-gravacao__onda simulador-gravacao__onda--previa">
        <span *ngFor="let ponto of barrasDoMedidor; let i = index"
              [class.simulador-gravacao__ponto--tocado]="i <= pontoTocado"></span>
        <b #marcadorPrevia class="simulador-gravacao__marcador"
           [class.simulador-gravacao__marcador--visivel]="pontoTocado >= 0"></b>
      </div>
      <span class="simulador-gravacao__tempo">{{ duracaoEmMinutos(audioPendente.duracaoSegundos) }}</span>
      <!-- pausado: continua a MESMA gravação; finalizado: regrava do zero -->
      <button class="simulador-gravacao__icone simulador-gravacao__icone--rec"
              (click)="pausado ? continueAGravacao() : regraveOAudio()"
              [title]="pausado ? 'Continuar gravando' : 'Regravar do início'">
        <i class="fas fa-microphone"></i>
      </button>
    </ng-container>

    <!-- some no celular: a configuração continua no ⚙ do cabeçalho -->
    <button class="simulador-gravacao__icone simulador-gravacao__icone--config"
            (click)="abraMicrofone()" title="Configurar microfone">
      <i class="fas fa-sliders-h"></i>
    </button>

    <!-- enviar fica no mesmo lugar nos dois estados; gravando, ele finaliza e manda -->
    <button class="simulador-gravacao__enviar" (click)="finalizeEEnvieAudio()"
            [disabled]="digitando" title="Enviar áudio">
      <i class="fas fa-paper-plane"></i>
    </button>
  </footer>

  <!-- barra de envio -->
  <footer class="simulador__rodape" *ngIf="!gravando && !audioPendente">
    <input #seletorImagem type="file" accept="image/jpeg,image/png,image/webp" hidden
           (change)="aoEscolherImagem($event)" />
    <button class="simulador__pin" (click)="seletorImagem.click()" [disabled]="digitando || emAtendimentoHumano"
            title="Enviar imagem (como no WhatsApp)">
      <i class="fas fa-camera"></i>
    </button>
    <button class="simulador__pin" (click)="envieLocalizacaoNaConversa()"
            [disabled]="digitando || localizacaoEnviando || emAtendimentoHumano"
            title="Enviar localização (como o clipe 📎 do WhatsApp)">
      <i class="fas" [class.fa-map-marker-alt]="!localizacaoEnviando" [class.fa-spinner]="localizacaoEnviando" [class.fa-spin]="localizacaoEnviando"></i>
    </button>
    <!-- microfone: só na tela de teste do painel (a Mia ainda não ouve áudios,
         então o widget público não convida o visitante a gravar) -->
    <button class="simulador__pin simulador__pin--mic" *ngIf="ehPainel"
            [class.simulador__pin--alerta]="problemaDoMicrofone"
            (click)="cliqueMicrofone()" [disabled]="digitando || emAtendimentoHumano"
            title="Gravar áudio (como o microfone do WhatsApp)">
      <i class="fas fa-microphone"></i>
      <span class="simulador__badge" *ngIf="problemaDoMicrofone"><i class="fas fa-exclamation"></i></span>
    </button>
    <input #campoMensagem type="text"
           [placeholder]="emAtendimentoHumano ? 'Conversa em atendimento humano…' : imagemPendente ? 'Legenda da imagem (opcional)…' : ehPainel ? 'Digite como se fosse o cliente…' : 'Digite sua mensagem…'"
           [(ngModel)]="textoDigitado" (keydown)="aoTeclar($event)"
           [disabled]="digitando || emAtendimentoHumano" />
    <button class="simulador__enviar" (click)="envie()"
            [disabled]="digitando || emAtendimentoHumano || (!textoDigitado.trim() && !imagemPendente)"
            title="Enviar (Enter)">
      <i class="fas fa-paper-plane"></i>
    </button>
  </footer>
</div>
